module.exports = __webpack_public_path__ + "static/media/mtg-card-not-found.74896750.jpg";